<template>
  <svg
    v-if="displayAll || name === 'arrow-left-icon'"
    width="29"
    height="29"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_8763_16374)">
      <path
        d="M24.84 13.3651L24.84 8.31459L13.4764 8.31459L17.8956 3.8954L14.84 0.839845L4.84 10.8398L14.84 20.8398L17.8956 17.7843L13.4764 13.3651L24.84 13.3651Z"
        fill="white"
        fill-opacity="0.9"
        shape-rendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_8763_16374"
        x="0.839996"
        y="0.839844"
        width="28"
        height="28"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8763_16374"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8763_16374"
          result="shape"
        />
      </filter>
    </defs>
  </svg>

  <svg
    v-if="displayAll || name === 'arrow-right-icon'"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 7.5C15 9.48912 14.2098 11.3968 12.8033 12.8033C11.3968 14.2098 9.48912 15 7.5 15C6.51509 15 5.53982 14.806 4.62987 14.4291C3.71993 14.0522 2.89314 13.4997 2.1967 12.8033C0.790176 11.3968 0 9.48912 0 7.5C0 5.51088 0.790176 3.60322 2.1967 2.1967C3.60322 0.790176 5.51088 0 7.5 0C8.48491 0 9.46018 0.193993 10.3701 0.570904C11.2801 0.947814 12.1069 1.50026 12.8033 2.1967C13.4997 2.89314 14.0522 3.71993 14.4291 4.62987C14.806 5.53982 15 6.51509 15 7.5ZM3 8.25H9L6.375 10.875L7.44 11.94L11.88 7.5L7.44 3.06L6.375 4.125L9 6.75H3V8.25Z"
      fill="#2F80ED"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'bio-icon'"
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2 0C16.6774 0 17.1352 0.189642 17.4728 0.527208C17.8104 0.864773 18 1.32261 18 1.8V12.6C18 13.0774 17.8104 13.5352 17.4728 13.8728C17.1352 14.2104 16.6774 14.4 16.2 14.4H1.8C1.32261 14.4 0.864773 14.2104 0.527208 13.8728C0.189642 13.5352 0 13.0774 0 12.6V1.8C0 1.32261 0.189642 0.864773 0.527208 0.527208C0.864773 0.189642 1.32261 0 1.8 0H16.2ZM16.2 12.6V1.8H1.8V12.6H16.2ZM3.6 5.4H5.4V7.2H3.6V5.4ZM3.6 9H10.8V10.8H3.6V9ZM12.6 9H14.4V10.8H12.6V9ZM7.2 5.4H14.4V7.2H7.2V5.4Z"
      fill="#E0E0E0"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'calendar-icon'"
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33333 8H3.55556V9.77778H5.33333V8ZM8.88889 8H7.11111V9.77778H8.88889V8ZM12.4444 8H10.6667V9.77778H12.4444V8ZM14.2222 1.77778H13.3333V0H11.5556V1.77778H4.44444V0H2.66667V1.77778H1.77778C0.791111 1.77778 0 2.57778 0 3.55556V16C0 16.4715 0.187301 16.9237 0.520699 17.2571C0.854097 17.5905 1.30628 17.7778 1.77778 17.7778H14.2222C14.6937 17.7778 15.1459 17.5905 15.4793 17.2571C15.8127 16.9237 16 16.4715 16 16V3.55556C16 3.08406 15.8127 2.63188 15.4793 2.29848C15.1459 1.96508 14.6937 1.77778 14.2222 1.77778ZM14.2222 16H1.77778V6.22222H14.2222V16Z"
      fill="#E0E0E0"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'camera-icon'"
    class="camera-icon"
    width="45"
    height="42"
    viewBox="0 0 45 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_8437_15695)">
      <path
        d="M37.3 3.77778H31.4355L28.05 0H16.95L13.5645 3.77778H7.7C6.7187 3.77778 5.77759 4.17579 5.0837 4.88426C4.38982 5.59273 4 6.55363 4 7.55556V30.2222C4 31.2241 4.38982 32.185 5.0837 32.8935C5.77759 33.602 6.7187 34 7.7 34H37.3C38.2813 34 39.2224 33.602 39.9163 32.8935C40.6102 32.185 41 31.2241 41 30.2222V7.55556C41 6.55363 40.6102 5.59273 39.9163 4.88426C39.2224 4.17579 38.2813 3.77778 37.3 3.77778ZM37.3 30.2222H7.7V7.55556H15.1925L18.578 3.77778H26.422L29.8075 7.55556H37.3V30.2222ZM22.5 9.44444C20.0467 9.44444 17.694 10.4395 15.9593 12.2107C14.2246 13.9818 13.25 16.3841 13.25 18.8889C13.25 21.3937 14.2246 23.7959 15.9593 25.5671C17.694 27.3383 20.0467 28.3333 22.5 28.3333C24.9533 28.3333 27.306 27.3383 29.0407 25.5671C30.7754 23.7959 31.75 21.3937 31.75 18.8889C31.75 16.3841 30.7754 13.9818 29.0407 12.2107C27.306 10.4395 24.9533 9.44444 22.5 9.44444ZM22.5 24.5556C21.028 24.5556 19.6164 23.9585 18.5756 22.8958C17.5347 21.8331 16.95 20.3918 16.95 18.8889C16.95 17.386 17.5347 15.9447 18.5756 14.8819C19.6164 13.8192 21.028 13.2222 22.5 13.2222C23.972 13.2222 25.3836 13.8192 26.4244 14.8819C27.4653 15.9447 28.05 17.386 28.05 18.8889C28.05 20.3918 27.4653 21.8331 26.4244 22.8958C25.3836 23.9585 23.972 24.5556 22.5 24.5556Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_8437_15695"
        x="0"
        y="0"
        width="45"
        height="42"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8437_15695"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8437_15695"
          result="shape"
        />
      </filter>
    </defs>
  </svg>

  <svg
    v-if="displayAll || name === 'check-icon'"
    width="12"
    height="10"
    viewBox="0 0 12 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.91243 9.79053L0 5.8781L1.78296 4.09514L3.91243 6.23091L10.137 0L11.92 1.78296L3.91243 9.79053Z"
      fill="#60A4E9"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'check-square-icon'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      d="M211.8 339.8C200.9 350.7 183.1 350.7 172.2 339.8L108.2 275.8C97.27 264.9 97.27 247.1 108.2 236.2C119.1 225.3 136.9 225.3 147.8 236.2L192 280.4L300.2 172.2C311.1 161.3 328.9 161.3 339.8 172.2C350.7 183.1 350.7 200.9 339.8 211.8L211.8 339.8zM0 96C0 60.65 28.65 32 64 32H384C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96zM48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80H64C55.16 80 48 87.16 48 96z"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'chevron-left-icon'"
    width="11"
    height="17"
    viewBox="0 0 11 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.41 14.8634L3.97575 8.42915L10.41 1.98085L8.42915 0L0 8.42915L8.42915 16.8583L10.41 14.8634Z"
      fill="#BDBDBD"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'circles-icon'"
    width="15"
    height="5"
    viewBox="0 0 15 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4642 2.4375C14.4642 2.85708 14.2949 3.25948 13.9935 3.55617C13.6921 3.85285 13.2833 4.01953 12.8571 4.01953C12.4308 4.01953 12.022 3.85285 11.7207 3.55617C11.4193 3.25948 11.2499 2.85708 11.2499 2.4375C11.2499 2.01792 11.4193 1.61552 11.7207 1.31883C12.022 1.02215 12.4308 0.855469 12.8571 0.855469C13.2833 0.855469 13.6921 1.02215 13.9935 1.31883C14.2949 1.61552 14.4642 2.01792 14.4642 2.4375ZM9.10707 2.4375C9.10707 2.64526 9.0655 2.85098 8.98474 3.04292C8.90397 3.23486 8.78559 3.40926 8.63635 3.55617C8.48712 3.70307 8.30995 3.8196 8.11496 3.89911C7.91997 3.97861 7.71098 4.01953 7.49993 4.01953C7.28888 4.01953 7.07989 3.97861 6.8849 3.89911C6.68992 3.8196 6.51275 3.70307 6.36351 3.55617C6.21427 3.40926 6.09589 3.23486 6.01512 3.04292C5.93436 2.85098 5.89279 2.64526 5.89279 2.4375C5.89279 2.22974 5.93436 2.02402 6.01512 1.83208C6.09589 1.64014 6.21427 1.46574 6.36351 1.31883C6.51275 1.17193 6.68992 1.0554 6.8849 0.975894C7.07989 0.896389 7.28888 0.855469 7.49993 0.855469C7.71098 0.855469 7.91997 0.896389 8.11496 0.975894C8.30995 1.0554 8.48712 1.17193 8.63635 1.31883C8.78559 1.46574 8.90397 1.64014 8.98474 1.83208C9.0655 2.02402 9.10707 2.22974 9.10707 2.4375ZM2.14279 4.01953C1.71655 4.01953 1.30776 3.85285 1.00637 3.55617C0.704968 3.25948 0.535645 2.85708 0.535645 2.4375C0.535645 2.01792 0.704968 1.61552 1.00637 1.31883C1.30776 1.02215 1.71655 0.855469 2.14279 0.855469C2.56903 0.855469 2.97781 1.02215 3.27921 1.31883C3.58061 1.61552 3.74993 2.01792 3.74993 2.4375C3.74993 2.85708 3.58061 3.25948 3.27921 3.55617C2.97781 3.85285 2.56903 4.01953 2.14279 4.01953Z"
      fill="#828282"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'close-icon'"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5188 1.88658C11.8454 1.55996 11.8454 1.0318 11.5188 0.708648C11.1921 0.385498 10.664 0.382024 10.3408 0.708648L6.2059 4.84358L2.06749 0.705174C1.74087 0.378549 1.21271 0.378549 0.889557 0.705174C0.566406 1.0318 0.562932 1.55996 0.889557 1.88311L5.02449 6.01804L0.886082 10.1564C0.559457 10.4831 0.559457 11.0112 0.886082 11.3344C1.21271 11.6575 1.74087 11.661 2.06402 11.3344L6.19895 7.19945L10.3374 11.3379C10.664 11.6645 11.1921 11.6645 11.5153 11.3379C11.8384 11.0112 11.8419 10.4831 11.5153 10.1599L7.38035 6.02499L11.5188 1.88658Z"
      fill="#828282"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'cog-icon'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.72933 6C10.7902 6 11.8076 6.42143 12.5578 7.17157C13.3079 7.92172 13.7293 8.93913 13.7293 10C13.7293 11.0609 13.3079 12.0783 12.5578 12.8284C11.8076 13.5786 10.7902 14 9.72933 14C8.66847 14 7.65105 13.5786 6.9009 12.8284C6.15076 12.0783 5.72933 11.0609 5.72933 10C5.72933 8.93913 6.15076 7.92172 6.9009 7.17157C7.65105 6.42143 8.66847 6 9.72933 6ZM9.72933 8C9.1989 8 8.69019 8.21071 8.31512 8.58579C7.94005 8.96086 7.72933 9.46957 7.72933 10C7.72933 10.5304 7.94005 11.0391 8.31512 11.4142C8.69019 11.7893 9.1989 12 9.72933 12C10.2598 12 10.7685 11.7893 11.1435 11.4142C11.5186 11.0391 11.7293 10.5304 11.7293 10C11.7293 9.46957 11.5186 8.96086 11.1435 8.58579C10.7685 8.21071 10.2598 8 9.72933 8ZM7.72933 20C7.47933 20 7.26933 19.82 7.22933 19.58L6.85933 16.93C6.22933 16.68 5.68933 16.34 5.16933 15.94L2.67933 16.95C2.45933 17.03 2.18933 16.95 2.06933 16.73L0.0693316 13.27C-0.0606684 13.05 -0.000668302 12.78 0.189332 12.63L2.29933 10.97L2.22933 10L2.29933 9L0.189332 7.37C-0.000668302 7.22 -0.0606684 6.95 0.0693316 6.73L2.06933 3.27C2.18933 3.05 2.45933 2.96 2.67933 3.05L5.16933 4.05C5.68933 3.66 6.22933 3.32 6.85933 3.07L7.22933 0.42C7.26933 0.18 7.47933 0 7.72933 0H11.7293C11.9793 0 12.1893 0.18 12.2293 0.42L12.5993 3.07C13.2293 3.32 13.7693 3.66 14.2893 4.05L16.7793 3.05C16.9993 2.96 17.2693 3.05 17.3893 3.27L19.3893 6.73C19.5193 6.95 19.4593 7.22 19.2693 7.37L17.1593 9L17.2293 10L17.1593 11L19.2693 12.63C19.4593 12.78 19.5193 13.05 19.3893 13.27L17.3893 16.73C17.2693 16.95 16.9993 17.04 16.7793 16.95L14.2893 15.95C13.7693 16.34 13.2293 16.68 12.5993 16.93L12.2293 19.58C12.1893 19.82 11.9793 20 11.7293 20H7.72933ZM8.97933 2L8.60933 4.61C7.40933 4.86 6.34933 5.5 5.57933 6.39L3.16933 5.35L2.41933 6.65L4.52933 8.2C4.12933 9.37 4.12933 10.64 4.52933 11.8L2.40933 13.36L3.15933 14.66L5.58933 13.62C6.35933 14.5 7.40933 15.14 8.59933 15.38L8.96933 18H10.4893L10.8593 15.39C12.0493 15.14 13.0993 14.5 13.8693 13.62L16.2993 14.66L17.0493 13.36L14.9293 11.81C15.3293 10.64 15.3293 9.37 14.9293 8.2L17.0393 6.65L16.2893 5.35L13.8793 6.39C13.1093 5.5 12.0493 4.86 10.8493 4.62L10.4793 2H8.97933Z"
      fill="#E0E0E0"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'comments-icon'"
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.57242 1.07143C4.21305 1.07143 1.07242 3.90402 1.07242 6.96429C1.07242 8.20647 1.59139 9.32812 2.41171 10.3125C2.58581 10.5234 2.69296 10.808 2.65948 11.1127C2.55568 12.0167 2.27778 12.8705 1.79898 13.6674C1.78224 13.6975 1.76215 13.7277 1.74541 13.7545C2.11706 13.6574 2.48872 13.5201 2.84028 13.3694C3.40948 13.1217 3.94519 12.8103 4.46081 12.452C4.74541 12.2545 5.11037 12.2009 5.43849 12.3114C6.46305 12.6596 7.50099 12.8571 8.57242 12.8571C12.9318 12.8571 16.0724 10.0246 16.0724 6.96429C16.0724 3.90402 12.9318 1.07143 8.57242 1.07143ZM0.000992916 6.96429C0.000992916 3.12054 3.8347 0 8.57242 0C13.3101 0 17.1439 3.12054 17.1439 6.96429C17.1439 10.808 13.3101 13.9286 8.57242 13.9286C7.36706 13.9286 6.21193 13.7042 5.09697 13.3292C5.09028 13.3259 5.08023 13.3292 5.07354 13.3326C4.50769 13.7243 3.91171 14.0725 3.26885 14.3538C2.46528 14.702 1.49764 15 0.536707 15C0.319073 15 0.124877 14.8694 0.0411715 14.6719C-0.0425339 14.4743 0.00434112 14.2433 0.155011 14.0893C0.426216 13.8147 0.663939 13.4799 0.881573 13.1183C1.27331 12.4621 1.50769 11.7589 1.59474 11.0056C1.59474 11.0056 1.59139 11.0022 1.59139 10.9989C0.657243 9.88058 0.000992916 8.52455 0.000992916 6.96429Z"
      fill="#828282"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'comments-small-icon'"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 21C10.2468 21 10.004 20.8994 9.82503 20.7204C9.64602 20.5414 9.54545 20.2986 9.54545 20.0455V17.1818H5.72727C5.22095 17.1818 4.73537 16.9807 4.37734 16.6227C4.01932 16.2646 3.81818 15.779 3.81818 15.2727V5.72727C3.81818 5.22095 4.01932 4.73537 4.37734 4.37734C4.73537 4.01932 5.22095 3.81818 5.72727 3.81818H19.0909C19.5972 3.81818 20.0828 4.01932 20.4408 4.37734C20.7989 4.73537 21 5.22095 21 5.72727V15.2727C21 15.779 20.7989 16.2646 20.4408 16.6227C20.0828 16.9807 19.5972 17.1818 19.0909 17.1818H15.1773L11.6455 20.7232C11.4545 20.895 11.2255 21 10.9773 21H10.5ZM11.4545 15.2727V18.2127L14.3945 15.2727H19.0909V5.72727H5.72727V15.2727H11.4545ZM1.90909 13.3636H0V1.90909C0 1.40277 0.201136 0.917184 0.55916 0.55916C0.917184 0.201136 1.40277 0 1.90909 0H17.1818V1.90909H1.90909V13.3636ZM7.63636 7.63636H17.1818V9.54545H7.63636V7.63636ZM7.63636 11.4545H15.2727V13.3636H7.63636V11.4545Z"
      fill="#BDBDBD"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'copy-icon'"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="19"
    viewBox="0 0 16 19"
    fill="none"
  >
    <path
      d="M14.3158 16.8421H5.05263V5.05263H14.3158M14.3158 3.36842H5.05263C4.60595 3.36842 4.17757 3.54586 3.86171 3.86172C3.54586 4.17757 3.36842 4.60595 3.36842 5.05263V16.8421C3.36842 17.2888 3.54586 17.7172 3.86171 18.033C4.17757 18.3489 4.60595 18.5263 5.05263 18.5263H14.3158C14.7625 18.5263 15.1909 18.3489 15.5067 18.033C15.8226 17.7172 16 17.2888 16 16.8421V5.05263C16 4.60595 15.8226 4.17757 15.5067 3.86172C15.1909 3.54586 14.7625 3.36842 14.3158 3.36842ZM11.7895 0H1.68421C1.23753 0 0.809144 0.177443 0.493294 0.493294C0.177443 0.809145 0 1.23753 0 1.68421V13.4737H1.68421V1.68421H11.7895V0Z"
      fill="#2F80ED"
    />
  </svg>

  <svg
    :class="'color-' + color"
    v-if="displayAll || name === 'crown-icon'"
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12.4319L0 1.07896L5.5 6.23939L9 0.046875L12.5 6.23939L18 1.07896L16 12.4319H2ZM16 15.5282C16 16.1474 15.6 16.5602 15 16.5602H3C2.4 16.5602 2 16.1474 2 15.5282V14.4961H16V15.5282Z"
      fill="#F2C94C"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'dots-icon'"
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_8763_16377)">
      <path
        d="M16.5 0C18.1415 0 19.767 0.323322 21.2835 0.951506C22.8001 1.57969 24.1781 2.50043 25.3388 3.66117C26.4996 4.8219 27.4203 6.19989 28.0485 7.71646C28.6767 9.23303 29 10.8585 29 12.5C29 15.8152 27.683 18.9946 25.3388 21.3388C22.9946 23.683 19.8152 25 16.5 25C14.8585 25 13.233 24.6767 11.7165 24.0485C10.1999 23.4203 8.8219 22.4996 7.66117 21.3388C5.31696 18.9946 4 15.8152 4 12.5C4 9.18479 5.31696 6.00537 7.66117 3.66117C10.0054 1.31696 13.1848 0 16.5 0ZM16.5 10.625C16.0027 10.625 15.5258 10.8225 15.1742 11.1742C14.8225 11.5258 14.625 12.0027 14.625 12.5C14.625 12.9973 14.8225 13.4742 15.1742 13.8258C15.5258 14.1775 16.0027 14.375 16.5 14.375C16.9973 14.375 17.4742 14.1775 17.8258 13.8258C18.1775 13.4742 18.375 12.9973 18.375 12.5C18.375 12.0027 18.1775 11.5258 17.8258 11.1742C17.4742 10.8225 16.9973 10.625 16.5 10.625ZM9.625 10.625C9.12772 10.625 8.65081 10.8225 8.29917 11.1742C7.94754 11.5258 7.75 12.0027 7.75 12.5C7.75 12.9973 7.94754 13.4742 8.29917 13.8258C8.65081 14.1775 9.12772 14.375 9.625 14.375C10.1223 14.375 10.5992 14.1775 10.9508 13.8258C11.3025 13.4742 11.5 12.9973 11.5 12.5C11.5 12.0027 11.3025 11.5258 10.9508 11.1742C10.5992 10.8225 10.1223 10.625 9.625 10.625ZM23.375 10.625C22.8777 10.625 22.4008 10.8225 22.0492 11.1742C21.6975 11.5258 21.5 12.0027 21.5 12.5C21.5 12.9973 21.6975 13.4742 22.0492 13.8258C22.4008 14.1775 22.8777 14.375 23.375 14.375C23.8723 14.375 24.3492 14.1775 24.7008 13.8258C25.0525 13.4742 25.25 12.9973 25.25 12.5C25.25 12.0027 25.0525 11.5258 24.7008 11.1742C24.3492 10.8225 23.8723 10.625 23.375 10.625Z"
        fill="white"
        fill-opacity="0.9"
        shape-rendering="crispEdges"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_8763_16377"
        x="0"
        y="0"
        width="33"
        height="33"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8763_16377"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_8763_16377"
          result="shape"
        />
      </filter>
    </defs>
  </svg>

  <svg
    v-if="displayAll || name === 'embed-icon'"
    width="25"
    height="19"
    viewBox="0 0 25 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_21619_447)">
      <path
        d="M15.5898 0.0412402C15.0938 -0.103486 14.5703 0.156279 14.418 0.627568L8.79297 17.8463C8.64062 18.3176 8.91406 18.8149 9.41016 18.9596C9.90625 19.1043 10.4297 18.8446 10.582 18.3733L16.207 1.15452C16.3594 0.683232 16.0859 0.185967 15.5898 0.0412402ZM18.3789 4.4387C18.0234 4.79866 18.043 5.36273 18.4219 5.69671L22.6914 9.50042L18.4219 13.3041C18.043 13.6418 18.0234 14.2059 18.3789 14.5621C18.7344 14.9184 19.3281 14.9407 19.7031 14.603L24.7031 10.1498C24.8906 9.98284 25 9.74534 25 9.50042C25 9.2555 24.8945 9.018 24.7031 8.85101L19.7031 4.39788C19.3242 4.06019 18.7305 4.07874 18.3789 4.4387ZM6.62109 4.4387C6.26562 4.07874 5.67188 4.06019 5.29688 4.39788L0.296875 8.85101C0.105469 9.018 0 9.2555 0 9.50042C0 9.74534 0.105469 9.98284 0.296875 10.1498L5.29688 14.603C5.67578 14.9407 6.26953 14.9221 6.62109 14.5621C6.97266 14.2022 6.95703 13.6381 6.57812 13.3041L2.30859 9.50042L6.57812 5.69671C6.95703 5.35901 6.97656 4.79495 6.62109 4.4387Z"
        fill="#4F4F4F"
      />
    </g>
    <defs>
      <clipPath id="clip0_21619_447">
        <rect width="25" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="displayAll || name === 'feed-icon'"
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_8367_17095)">
      <path
        d="M3.1571 0V0.919985C13.5907 0.919985 22.0788 9.4084 22.0788 19.842H22.9988C22.9989 8.90127 14.0978 0 3.1571 0Z"
        fill="#828282"
      />
      <path
        d="M3.1571 4.17188V5.09186C11.2909 5.09186 17.9081 11.7093 17.9081 19.8428H18.8281C18.8281 11.2017 11.7981 4.17188 3.1571 4.17188Z"
        fill="#828282"
      />
      <path
        d="M3.1571 8.33984V9.25983C8.9911 9.25983 13.7373 14.0063 13.7373 19.8403H14.6573C14.6573 13.4991 9.49828 8.33984 3.1571 8.33984Z"
        fill="#828282"
      />
      <path
        d="M3.1571 12.5117V13.4317C6.69133 13.4317 9.56654 16.3071 9.56654 19.8411H10.4865C10.4866 15.7995 7.19851 12.5117 3.1571 12.5117Z"
        fill="#828282"
      />
      <path
        d="M3.15823 16.6836C1.41684 16.6836 0 18.1004 0 19.8421C0 21.5832 1.41684 23.0001 3.15823 23.0001C4.89986 23.0001 6.3167 21.5832 6.3167 19.8421C6.3167 18.1004 4.89986 16.6836 3.15823 16.6836ZM3.15823 22.08C1.92402 22.08 0.919985 21.076 0.919985 19.842C0.919985 18.6076 1.92397 17.6036 3.15823 17.6036C4.39249 17.6036 5.39667 18.6076 5.39667 19.842C5.39667 21.076 4.39245 22.08 3.15823 22.08Z"
        fill="#828282"
      />
    </g>
    <defs>
      <clipPath id="clip0_8367_17095">
        <rect width="23" height="23" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="displayAll || name === 'followers-icon'"
    width="24"
    height="15"
    viewBox="0 0 24 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0C12.9283 0 13.8185 0.368749 14.4749 1.02513C15.1313 1.6815 15.5 2.57174 15.5 3.5C15.5 4.42826 15.1313 5.3185 14.4749 5.97487C13.8185 6.63125 12.9283 7 12 7C11.0717 7 10.1815 6.63125 9.52513 5.97487C8.86875 5.3185 8.5 4.42826 8.5 3.5C8.5 2.57174 8.86875 1.6815 9.52513 1.02513C10.1815 0.368749 11.0717 0 12 0ZM5 2.5C5.56 2.5 6.08 2.65 6.53 2.92C6.38 4.35 6.8 5.77 7.66 6.88C7.16 7.84 6.16 8.5 5 8.5C4.20435 8.5 3.44129 8.18393 2.87868 7.62132C2.31607 7.05871 2 6.29565 2 5.5C2 4.70435 2.31607 3.94129 2.87868 3.37868C3.44129 2.81607 4.20435 2.5 5 2.5ZM19 2.5C19.7956 2.5 20.5587 2.81607 21.1213 3.37868C21.6839 3.94129 22 4.70435 22 5.5C22 6.29565 21.6839 7.05871 21.1213 7.62132C20.5587 8.18393 19.7956 8.5 19 8.5C17.84 8.5 16.84 7.84 16.34 6.88C17.2 5.77 17.62 4.35 17.47 2.92C17.92 2.65 18.44 2.5 19 2.5ZM5.5 12.75C5.5 10.68 8.41 9 12 9C15.59 9 18.5 10.68 18.5 12.75V14.5H5.5V12.75ZM0 14.5V13C0 11.61 1.89 10.44 4.45 10.1C3.86 10.78 3.5 11.72 3.5 12.75V14.5H0ZM24 14.5H20.5V12.75C20.5 11.72 20.14 10.78 19.55 10.1C22.11 10.44 24 11.61 24 13V14.5Z"
      fill="#BDBDBD"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'following-icon'"
    width="23"
    height="14"
    viewBox="0 0 23 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 12V14H6V12C6 12 6 8 12 8C18 8 18 12 18 12ZM15 3C15 2.40666 14.8241 1.82664 14.4944 1.33329C14.1648 0.839943 13.6962 0.455426 13.1481 0.228363C12.5999 0.00129986 11.9967 -0.0581102 11.4147 0.0576455C10.8328 0.173401 10.2982 0.459123 9.87868 0.878681C9.45912 1.29824 9.1734 1.83279 9.05764 2.41473C8.94189 2.99667 9.0013 3.59987 9.22836 4.14805C9.45542 4.69623 9.83994 5.16477 10.3333 5.49441C10.8266 5.82405 11.4067 6 12 6C12.7956 6 13.5587 5.68393 14.1213 5.12132C14.6839 4.55871 15 3.79565 15 3ZM18.2 8.06C18.7466 8.5643 19.1873 9.17244 19.4964 9.84891C19.8054 10.5254 19.9766 11.2566 20 12V14H23V12C23 12 23 8.55 18.2 8.06ZM17 1.1415e-06C16.6979 0.000181955 16.3976 0.0474144 16.11 0.140001C16.6951 0.97897 17.0087 1.97718 17.0087 3C17.0087 4.02282 16.6951 5.02103 16.11 5.86C16.3976 5.95259 16.6979 5.99982 17 6C17.7956 6 18.5587 5.68393 19.1213 5.12132C19.6839 4.55871 20 3.79565 20 3C20 2.20435 19.6839 1.44129 19.1213 0.878681C18.5587 0.316072 17.7956 1.1415e-06 17 1.1415e-06ZM6.34 3.92L7.5 5.33L2.75 10.08L0 7.08L1.16 5.92L2.75 7.5L6.34 3.92Z"
      fill="#BDBDBD"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'hide-icon'"
    width="24"
    height="21"
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_21619_445)">
      <path
        d="M1.45521 0.209227C1.06521 -0.127101 0.498961 -0.0491713 0.191461 0.377391C-0.116039 0.803954 -0.0447892 1.42329 0.345211 1.75962L22.5452 20.7909C22.9352 21.1272 23.5015 21.0493 23.809 20.6227C24.1165 20.1961 24.0452 19.5768 23.6552 19.2405L19.7102 15.8608C21.1952 14.1956 22.2002 12.3293 22.7065 11.0045C22.8302 10.6805 22.8302 10.3196 22.7065 9.99556C22.1477 8.5313 20.974 6.39849 19.219 4.61841C17.4565 2.82192 15.0302 1.31255 12.0002 1.31255C9.44271 1.31255 7.31271 2.39126 5.65146 3.8063L1.45521 0.209227ZM7.11771 5.06138C8.47521 4.00727 10.1065 3.2813 12.0002 3.2813C14.4452 3.2813 16.4552 4.49536 17.9965 6.05806C19.4402 7.52641 20.4377 9.26958 20.9477 10.5C20.4752 11.6485 19.5752 13.2399 18.289 14.6385L16.2715 12.9077C16.6127 12.1858 16.804 11.3696 16.804 10.5C16.804 7.60024 14.6552 5.25005 12.004 5.25005C10.7965 5.25005 9.69021 5.73813 8.84646 6.54204L7.11771 5.06138ZM14.809 11.6567L11.7527 9.03579C11.9102 8.68716 12.0002 8.28931 12.0002 7.87505C12.0002 7.64946 11.974 7.42798 11.9252 7.2188C11.9515 7.2188 11.974 7.2188 12.0002 7.2188C13.6577 7.2188 15.0002 8.68716 15.0002 10.5C15.0002 10.9061 14.9327 11.2958 14.809 11.6567ZM15.1615 17.001C14.2052 17.4481 13.1515 17.7188 12.0002 17.7188C9.55521 17.7188 7.54521 16.5047 6.00396 14.942C4.56021 13.4737 3.56271 11.7305 3.05271 10.5C3.36396 9.74536 3.85896 8.7979 4.53021 7.84224L3.11646 6.62407C2.26146 7.84224 1.65021 9.0563 1.29396 9.99556C1.17021 10.3196 1.17021 10.6805 1.29396 11.0045C1.85271 12.4688 3.02646 14.6016 4.78146 16.3817C6.54396 18.1782 8.97021 19.6875 12.0002 19.6875C13.7927 19.6875 15.3715 19.1584 16.7327 18.3545L15.1615 17.001ZM7.20021 10.5C7.20021 13.3999 9.34896 15.75 12.0002 15.75C12.499 15.75 12.979 15.668 13.4327 15.5122L11.3252 13.6993C10.444 13.4778 9.70896 12.8297 9.31146 11.9643L7.20771 10.1514C7.20021 10.2663 7.19646 10.3811 7.19646 10.5H7.20021Z"
        fill="#4F4F4F"
      />
    </g>
    <defs>
      <clipPath id="clip0_21619_445">
        <rect width="24" height="21" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="displayAll || name === 'login-icon'"
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0)">
      <path
        d="M17.4375 14.0625H0.5625C0.252 14.0625 0 13.8105 0 13.5C0 13.1895 0.252 12.9375 0.5625 12.9375H17.4375C17.748 12.9375 18 13.1895 18 13.5C18 13.8105 17.748 14.0625 17.4375 14.0625Z"
        fill="#C4C4C4"
      />
      <path
        d="M12.9375 18.5625C12.7935 18.5625 12.6495 18.5074 12.5392 18.3983C12.3199 18.1789 12.3199 17.8223 12.5392 17.6029L16.6421 13.5L12.5404 9.39826C12.321 9.17889 12.321 8.82226 12.5404 8.60289C12.7597 8.38351 13.1164 8.38351 13.3357 8.60289L17.8357 13.1029C18.0551 13.3223 18.0551 13.6789 17.8357 13.8983L13.3357 18.3983C13.2255 18.5074 13.0815 18.5625 12.9375 18.5625Z"
        fill="#C4C4C4"
      />
      <path
        d="M13.5 25.875C8.26317 25.875 3.57417 22.5596 1.83154 17.6254C1.72804 17.3317 1.88217 17.0111 2.17467 16.9076C2.46829 16.8064 2.78892 16.9582 2.89242 17.2507C4.47642 21.7361 8.73904 24.75 13.5 24.75C19.7033 24.75 24.75 19.7032 24.75 13.5C24.75 7.29675 19.7033 2.25 13.5 2.25C8.73904 2.25 4.47642 5.26387 2.89354 9.75037C2.79004 10.0429 2.46829 10.1947 2.17579 10.0935C1.88329 9.99 1.72917 9.66937 1.83267 9.37575C3.57417 4.44037 8.26317 1.125 13.5 1.125C20.3232 1.125 25.875 6.67687 25.875 13.5C25.875 20.3231 20.3232 25.875 13.5 25.875Z"
        fill="#C4C4C4"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="27" height="27" fill="white" />
      </clipPath>
    </defs>
  </svg>

  <svg
    v-if="displayAll || name === 'pin-icon'"
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 4.05C7.66304 4.05 8.29893 4.28705 8.76777 4.70901C9.23661 5.13097 9.5 5.70326 9.5 6.3C9.5 6.59547 9.43534 6.88806 9.3097 7.16104C9.18406 7.43402 8.99991 7.68206 8.76777 7.89099C8.53562 8.09992 8.26002 8.26566 7.95671 8.37873C7.65339 8.4918 7.3283 8.55 7 8.55C6.33696 8.55 5.70107 8.31295 5.23223 7.89099C4.76339 7.46903 4.5 6.89674 4.5 6.3C4.5 5.70326 4.76339 5.13097 5.23223 4.70901C5.70107 4.28705 6.33696 4.05 7 4.05ZM7 0C8.85652 0 10.637 0.663748 11.9497 1.84523C13.2625 3.02671 14 4.62914 14 6.3C14 11.025 7 18 7 18C7 18 0 11.025 0 6.3C0 4.62914 0.737498 3.02671 2.05025 1.84523C3.36301 0.663748 5.14348 0 7 0ZM7 1.8C5.67392 1.8 4.40215 2.27411 3.46447 3.11802C2.52678 3.96193 2 5.10653 2 6.3C2 7.2 2 9 7 15.039C12 9 12 7.2 12 6.3C12 5.10653 11.4732 3.96193 10.5355 3.11802C9.59785 2.27411 8.32608 1.8 7 1.8Z"
      fill="#E0E0E0"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'points-icon'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.23 16L10 13.45L5.77 16L6.89 11.19L3.16 7.96L8.08 7.54L10 3L11.92 7.53L16.84 7.95L13.11 11.18L14.23 16ZM10 0C4.47 0 0 4.5 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z"
      fill="#BDBDBD"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'share-icon'"
    width="20"
    height="25"
    viewBox="0 0 20 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.7589 0.341736C10.3393 -0.117249 9.66072 -0.117249 9.24554 0.341736L3.52679 6.59174C3.10714 7.05072 3.10714 7.79291 3.52679 8.24701C3.94643 8.70111 4.625 8.70599 5.04018 8.24701L8.92411 3.99896V16.0156C8.92411 16.665 9.40179 17.1874 9.99554 17.1874C10.5893 17.1874 11.067 16.665 11.067 16.0156V3.99896L14.9509 8.24701C15.3705 8.70599 16.0491 8.70599 16.4643 8.24701C16.8795 7.78803 16.8839 7.04584 16.4643 6.59174L10.7589 0.341736ZM2.14286 16.7968C2.14286 16.1474 1.66518 15.6249 1.07143 15.6249C0.477679 15.6249 0 16.1474 0 16.7968V20.7031C0 23.0761 1.75893 24.9999 3.92857 24.9999H16.0714C18.2411 24.9999 20 23.0761 20 20.7031V16.7968C20 16.1474 19.5223 15.6249 18.9286 15.6249C18.3348 15.6249 17.8571 16.1474 17.8571 16.7968V20.7031C17.8571 21.7822 17.058 22.6562 16.0714 22.6562H3.92857C2.94196 22.6562 2.14286 21.7822 2.14286 20.7031V16.7968Z"
      fill="#4F4F4F"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'thumb-up-empty-icon'"
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.87109 1.66721C9.99072 1.23874 10.4419 0.987679 10.8794 1.10484C11.3169 1.222 11.5732 1.66386 11.4536 2.09233L11.2998 2.64131C11.1118 3.31749 10.8247 3.95685 10.4556 4.54599C10.3496 4.71002 10.3462 4.91756 10.4419 5.08827C10.5376 5.25899 10.7222 5.36276 10.9204 5.36276H15.3125C15.9175 5.36276 16.4063 5.84145 16.4063 6.43394C16.4063 6.8122 16.2046 7.14694 15.9004 7.33774C15.6543 7.49173 15.5757 7.80304 15.7192 8.05075C15.8081 8.20473 15.8594 8.38549 15.8594 8.57629C15.8594 8.99137 15.6201 9.34955 15.2681 9.53031C15.1245 9.60395 15.0186 9.7345 14.9844 9.89183C14.9502 10.0492 14.9878 10.2098 15.0869 10.3337C15.2305 10.5145 15.3159 10.7421 15.3159 10.9864C15.3159 11.4618 15.0015 11.8668 14.5605 12.0041C14.2939 12.0911 14.1367 12.3589 14.1948 12.6267C14.2119 12.7003 14.2188 12.7773 14.2188 12.8576C14.2188 13.4501 13.73 13.9288 13.125 13.9288H10.0659C9.52588 13.9288 8.99951 13.7715 8.54834 13.4803L7.23242 12.62C6.92481 12.4191 6.66504 12.1614 6.4668 11.8635C6.29932 11.6158 5.96094 11.5488 5.70801 11.7095C5.45508 11.8702 5.38672 12.2049 5.55078 12.4526C5.82764 12.8643 6.18994 13.2259 6.62402 13.5104L7.93994 14.3707C8.56885 14.7824 9.30713 15 10.0625 15H13.125C14.3315 15 15.3125 14.0393 15.3125 12.8576V12.8376C15.9653 12.466 16.4063 11.7764 16.4063 10.9831C16.4063 10.6919 16.3447 10.4107 16.2388 10.1563C16.6763 9.76463 16.9531 9.20226 16.9531 8.57294C16.9531 8.35536 16.9189 8.14447 16.8574 7.94698C17.2539 7.55867 17.5 7.02309 17.5 6.43059C17.5 5.24895 16.519 4.28824 15.3125 4.28824H11.8398C12.0518 3.84973 12.2261 3.39448 12.356 2.91914L12.5098 2.37017C12.7866 1.37263 12.1851 0.341626 11.1665 0.0671371C10.148 -0.207352 9.09522 0.385142 8.81494 1.38268L8.66113 1.93165C8.35693 3.02291 7.64942 3.96689 6.67188 4.57612L6.56592 4.64307C6.1626 4.89412 5.82422 5.21548 5.55762 5.58704C5.3833 5.82806 5.44483 6.1628 5.69434 6.33352C5.94385 6.50424 6.28223 6.44398 6.45654 6.19962C6.64111 5.94187 6.87354 5.71759 7.15381 5.54687L7.25977 5.47992C8.46631 4.7301 9.34131 3.5652 9.71729 2.21618L9.87109 1.66721ZM1.09375 6.43059H3.28125V13.9288H1.09375V6.43059ZM0 6.43059V13.9288C0 14.5213 0.48877 15 1.09375 15H3.28125C3.88623 15 4.375 14.5213 4.375 13.9288V6.43059C4.375 5.8381 3.88623 5.35942 3.28125 5.35942H1.09375C0.48877 5.35942 0 5.8381 0 6.43059Z"
      fill="#828282"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'thumb-up-icon'"
    class="thumb-icon"
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4059 0.0924901C11.2691 0.265146 11.8303 1.10519 11.6576 1.96847L11.5812 2.34698C11.4053 3.23351 11.0799 4.07686 10.625 4.84386H15.4062C16.2861 4.84386 17 5.55772 17 6.43761C17 7.05186 16.6514 7.58643 16.14 7.85206C16.502 8.14425 16.7344 8.59249 16.7344 9.09386C16.7344 9.87081 16.1766 10.5183 15.4428 10.6577C15.5889 10.9001 15.6719 11.1823 15.6719 11.4845C15.6719 12.1917 15.2104 12.7927 14.5729 12.9985C14.5961 13.1081 14.6094 13.2243 14.6094 13.3439C14.6094 14.2237 13.8955 14.9376 13.0156 14.9376H9.77832C9.14746 14.9376 8.5332 14.7517 8.00859 14.403L6.73027 13.5497C5.84375 12.9587 5.3125 11.9626 5.3125 10.8968V9.62511V8.03136V7.2046C5.3125 6.23507 5.7541 5.32198 6.50781 4.71436L6.75352 4.51847C7.6334 3.81456 8.23438 2.82511 8.45352 1.72276L8.52988 1.34425C8.70254 0.480967 9.54258 -0.0801661 10.4059 0.0924901ZM1.0625 5.37511H3.1875C3.7752 5.37511 4.25 5.84991 4.25 6.43761V13.8751C4.25 14.4628 3.7752 14.9376 3.1875 14.9376H1.0625C0.474805 14.9376 0 14.4628 0 13.8751V6.43761C0 5.84991 0.474805 5.37511 1.0625 5.37511Z"
      fill="#4F4F4F"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'thumb-down-empty-icon'"
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      style="transform: scaleY(-1); transform-origin: center center"
      d="M9.87109 1.66721C9.99072 1.23874 10.4419 0.987679 10.8794 1.10484C11.3169 1.222 11.5732 1.66386 11.4536 2.09233L11.2998 2.64131C11.1118 3.31749 10.8247 3.95685 10.4556 4.54599C10.3496 4.71002 10.3462 4.91756 10.4419 5.08827C10.5376 5.25899 10.7222 5.36276 10.9204 5.36276H15.3125C15.9175 5.36276 16.4063 5.84145 16.4063 6.43394C16.4063 6.8122 16.2046 7.14694 15.9004 7.33774C15.6543 7.49173 15.5757 7.80304 15.7192 8.05075C15.8081 8.20473 15.8594 8.38549 15.8594 8.57629C15.8594 8.99137 15.6201 9.34955 15.2681 9.53031C15.1245 9.60395 15.0186 9.7345 14.9844 9.89183C14.9502 10.0492 14.9878 10.2098 15.0869 10.3337C15.2305 10.5145 15.3159 10.7421 15.3159 10.9864C15.3159 11.4618 15.0015 11.8668 14.5605 12.0041C14.2939 12.0911 14.1367 12.3589 14.1948 12.6267C14.2119 12.7003 14.2188 12.7773 14.2188 12.8576C14.2188 13.4501 13.73 13.9288 13.125 13.9288H10.0659C9.52588 13.9288 8.99951 13.7715 8.54834 13.4803L7.23242 12.62C6.92481 12.4191 6.66504 12.1614 6.4668 11.8635C6.29932 11.6158 5.96094 11.5488 5.70801 11.7095C5.45508 11.8702 5.38672 12.2049 5.55078 12.4526C5.82764 12.8643 6.18994 13.2259 6.62402 13.5104L7.93994 14.3707C8.56885 14.7824 9.30713 15 10.0625 15H13.125C14.3315 15 15.3125 14.0393 15.3125 12.8576V12.8376C15.9653 12.466 16.4063 11.7764 16.4063 10.9831C16.4063 10.6919 16.3447 10.4107 16.2388 10.1563C16.6763 9.76463 16.9531 9.20226 16.9531 8.57294C16.9531 8.35536 16.9189 8.14447 16.8574 7.94698C17.2539 7.55867 17.5 7.02309 17.5 6.43059C17.5 5.24895 16.519 4.28824 15.3125 4.28824H11.8398C12.0518 3.84973 12.2261 3.39448 12.356 2.91914L12.5098 2.37017C12.7866 1.37263 12.1851 0.341626 11.1665 0.0671371C10.148 -0.207352 9.09522 0.385142 8.81494 1.38268L8.66113 1.93165C8.35693 3.02291 7.64942 3.96689 6.67188 4.57612L6.56592 4.64307C6.1626 4.89412 5.82422 5.21548 5.55762 5.58704C5.3833 5.82806 5.44483 6.1628 5.69434 6.33352C5.94385 6.50424 6.28223 6.44398 6.45654 6.19962C6.64111 5.94187 6.87354 5.71759 7.15381 5.54687L7.25977 5.47992C8.46631 4.7301 9.34131 3.5652 9.71729 2.21618L9.87109 1.66721ZM1.09375 6.43059H3.28125V13.9288H1.09375V6.43059ZM0 6.43059V13.9288C0 14.5213 0.48877 15 1.09375 15H3.28125C3.88623 15 4.375 14.5213 4.375 13.9288V6.43059C4.375 5.8381 3.88623 5.35942 3.28125 5.35942H1.09375C0.48877 5.35942 0 5.8381 0 6.43059Z"
      fill="#828282"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'thumb-down-icon'"
    class="thumb-icon"
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      style="transform: scaleY(-1); transform-origin: center center"
      d="M10.4059 0.0924901C11.2691 0.265146 11.8303 1.10519 11.6576 1.96847L11.5812 2.34698C11.4053 3.23351 11.0799 4.07686 10.625 4.84386H15.4062C16.2861 4.84386 17 5.55772 17 6.43761C17 7.05186 16.6514 7.58643 16.14 7.85206C16.502 8.14425 16.7344 8.59249 16.7344 9.09386C16.7344 9.87081 16.1766 10.5183 15.4428 10.6577C15.5889 10.9001 15.6719 11.1823 15.6719 11.4845C15.6719 12.1917 15.2104 12.7927 14.5729 12.9985C14.5961 13.1081 14.6094 13.2243 14.6094 13.3439C14.6094 14.2237 13.8955 14.9376 13.0156 14.9376H9.77832C9.14746 14.9376 8.5332 14.7517 8.00859 14.403L6.73027 13.5497C5.84375 12.9587 5.3125 11.9626 5.3125 10.8968V9.62511V8.03136V7.2046C5.3125 6.23507 5.7541 5.32198 6.50781 4.71436L6.75352 4.51847C7.6334 3.81456 8.23438 2.82511 8.45352 1.72276L8.52988 1.34425C8.70254 0.480967 9.54258 -0.0801661 10.4059 0.0924901ZM1.0625 5.37511H3.1875C3.7752 5.37511 4.25 5.84991 4.25 6.43761V13.8751C4.25 14.4628 3.7752 14.9376 3.1875 14.9376H1.0625C0.474805 14.9376 0 14.4628 0 13.8751V6.43761C0 5.84991 0.474805 5.37511 1.0625 5.37511Z"
      fill="#4F4F4F"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'user-icon'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10.875" stroke="#4F4F4F" stroke-width="2.25" />
    <path
      d="M12 11.5C13.5781 11.5 14.8571 10.2689 14.8571 8.75C14.8571 7.23105 13.5781 6 12 6C10.4219 6 9.14286 7.23105 9.14286 8.75C9.14286 10.2689 10.4219 11.5 12 11.5ZM14 12.1875H13.6272C13.1317 12.4066 12.5804 12.5312 12 12.5312C11.4196 12.5312 10.8705 12.4066 10.3728 12.1875H10C8.34375 12.1875 7 13.4809 7 15.075V15.9688C7 16.5381 7.47991 17 8.07143 17H15.9286C16.5201 17 17 16.5381 17 15.9688V15.075C17 13.4809 15.6562 12.1875 14 12.1875Z"
      fill="#4F4F4F"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'votes-icon'"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 0.9375C9.24048 0.9375 10.9097 1.6289 12.1404 2.85961C13.3711 4.09032 14.0625 5.75952 14.0625 7.5C14.0625 9.24048 13.3711 10.9097 12.1404 12.1404C10.9097 13.3711 9.24048 14.0625 7.5 14.0625C5.75952 14.0625 4.09032 13.3711 2.85961 12.1404C1.6289 10.9097 0.9375 9.24048 0.9375 7.5C0.9375 5.75952 1.6289 4.09032 2.85961 2.85961C4.09032 1.6289 5.75952 0.9375 7.5 0.9375ZM7.5 15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48912 0 7.5 0C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5C0 9.48912 0.790176 11.3968 2.1967 12.8033C3.60322 14.2098 5.51088 15 7.5 15ZM10.6436 5.95605C10.8252 5.77441 10.8252 5.47559 10.6436 5.29395C10.4619 5.1123 10.1631 5.1123 9.98145 5.29395L6.5625 8.71289L5.01855 7.16895C4.83691 6.9873 4.53809 6.9873 4.35645 7.16895C4.1748 7.35059 4.1748 7.64941 4.35645 7.83105L6.23145 9.70605C6.41309 9.8877 6.71191 9.8877 6.89355 9.70605L10.6436 5.95605Z"
      fill="#828282"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'vote-icon'"
    class="vote-icon"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48912 0 7.5 0C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5C0 9.48912 0.790176 11.3968 2.1967 12.8033C3.60322 14.2098 5.51088 15 7.5 15ZM10.8105 6.12305L7.06055 9.87305C6.78516 10.1484 6.33984 10.1484 6.06738 9.87305L4.19238 7.99805C3.91699 7.72266 3.91699 7.27734 4.19238 7.00488C4.46777 6.73242 4.91309 6.72949 5.18555 7.00488L6.5625 8.38184L9.81445 5.12695C10.0898 4.85156 10.5352 4.85156 10.8076 5.12695C11.0801 5.40234 11.083 5.84766 10.8076 6.12012L10.8105 6.12305Z"
      :fill="pathFill"
    />
  </svg>

  <svg
    v-if="displayAll || name === 'votes-icon'"
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 0.9375C9.24048 0.9375 10.9097 1.6289 12.1404 2.85961C13.3711 4.09032 14.0625 5.75952 14.0625 7.5C14.0625 9.24048 13.3711 10.9097 12.1404 12.1404C10.9097 13.3711 9.24048 14.0625 7.5 14.0625C5.75952 14.0625 4.09032 13.3711 2.85961 12.1404C1.6289 10.9097 0.9375 9.24048 0.9375 7.5C0.9375 5.75952 1.6289 4.09032 2.85961 2.85961C4.09032 1.6289 5.75952 0.9375 7.5 0.9375ZM7.5 15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48912 0 7.5 0C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5C0 9.48912 0.790176 11.3968 2.1967 12.8033C3.60322 14.2098 5.51088 15 7.5 15ZM10.6436 5.95605C10.8252 5.77441 10.8252 5.47559 10.6436 5.29395C10.4619 5.1123 10.1631 5.1123 9.98145 5.29395L6.5625 8.71289L5.01855 7.16895C4.83691 6.9873 4.53809 6.9873 4.35645 7.16895C4.1748 7.35059 4.1748 7.64941 4.35645 7.83105L6.23145 9.70605C6.41309 9.8877 6.71191 9.8877 6.89355 9.70605L10.6436 5.95605Z"
      fill="#828282"
    />
  </svg>

  <svg
    class="reply-icon"
    v-if="displayAll || name === 'reply-icon'"
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.57144 2.00893C4.21207 2.00893 1.07144 4.84152 1.07144 7.90179C1.07144 9.14397 1.59042 10.2656 2.41073 11.25C2.58484 11.4609 2.69198 11.7455 2.6585 12.0502C2.5547 12.9542 2.2768 13.808 1.79801 14.6049C1.78127 14.635 1.76118 14.6652 1.74444 14.692C2.11609 14.5949 2.48774 14.4576 2.8393 14.3069C3.4085 14.0592 3.94421 13.7478 4.45984 13.3895C4.74444 13.192 5.10939 13.1384 5.43752 13.2489C6.46207 13.5971 7.50002 13.7946 8.57144 13.7946C12.9308 13.7946 16.0714 10.9621 16.0714 7.90179C16.0714 4.84152 12.9308 2.00893 8.57144 2.00893ZM1.63538e-05 7.90179C1.63538e-05 4.05804 3.83372 0.9375 8.57144 0.9375C13.3092 0.9375 17.1429 4.05804 17.1429 7.90179C17.1429 11.7455 13.3092 14.8661 8.57144 14.8661C7.36609 14.8661 6.21095 14.6417 5.096 14.2667C5.0893 14.2634 5.07926 14.2667 5.07256 14.2701C4.50671 14.6618 3.91073 15.01 3.26787 15.2913C2.4643 15.6395 1.49667 15.9375 0.535731 15.9375C0.318097 15.9375 0.1239 15.8069 0.0401949 15.6094C-0.0435104 15.4118 0.00336456 15.1808 0.154034 15.0268C0.42524 14.7522 0.662963 14.4174 0.880597 14.0558C1.27234 13.3996 1.50671 12.6964 1.59377 11.9431C1.59377 11.9431 1.59042 11.9397 1.59042 11.9364C0.656266 10.8181 1.63538e-05 9.46205 1.63538e-05 7.90179Z"
      fill="#828282"
    />
  </svg>
</template>

<script>
export default {
  name: "SvgElement",
  props: {
    name: {
      type: String,
      default: "",
    },
    color: {
      type: String,
      default: "standard",
    },
    pathFill: {
      type: String,
      default: "#828282",
    },
    displayAll: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
